import { render, staticRenderFns } from "./EditMentorshipGroup.vue?vue&type=template&id=7f0c7171"
import script from "./EditMentorshipGroup.vue?vue&type=script&lang=js"
export * from "./EditMentorshipGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports